
import React, { useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useMounted from '../../hooks/useMounted';


import SimpleReactValidator from 'simple-react-validator';
import { post } from '../../helpers/api_helper';
import { POST_GET_SHADE_DETAIL, POST_ADD_EDIT_SHADE } from '../../helpers/url_helper';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';

const Item = (props) => {
    const navigate = useNavigate();

    const [isLoader, setLoader] = useState(0);

    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({ shadeId: 0, shadeName: '', shadeCode : '', shadeDisplayIndex: '' });
    const [, forceUpdate] = useState();

    const { id } = useParams()

    useMounted(() => {
        async function get_detaile() {
            if (id) {
                var res_data = await post(POST_GET_SHADE_DETAIL, { 'id': id });
                if (res_data.status) {
                    setInputs(res_data.data.shadeDetail);
                } else {
                    toast.error(res_data.message);
                    navigate("/");
                }
            }
            setLoader(1)
        }
        get_detaile();
    }, [])

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_ADD_EDIT_SHADE, form_inputs, {});
            if (res_data.status) {
                toast(res_data.message);
                navigate("/shades");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
    }



    if (!isLoader) {
        return (<Loader />);
    }
    return (
        <>
            <div className='row'>
                <div className="col-md-6">
                    <div className="card mb-4">
                        <h5 className="card-header">Shade</h5>
                        <div className="card-body">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Name *</label>
                                    <input name="shadeName" value={form_inputs.shadeName} onChange={handleInputChange} className="form-control" placeholder="Enter Name" type="text" />
                                    {simpleValidator.current.message('name', form_inputs.shadeName, 'required')}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Code *</label>
                                    <input name="shadeCode" value={form_inputs.shadeCode} onChange={handleInputChange} className="form-control" placeholder="Enter Code" type="text" />
                                    {simpleValidator.current.message('code', form_inputs.shadeCode, 'required')}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">Display Index </label>
                                    <input name="shadeDisplayIndex" value={form_inputs.shadeDisplayIndex} onChange={handleInputChange} className="form-control" placeholder="Enter Display Index" type="text" />
                                    {simpleValidator.current.message('index', form_inputs.shadeDisplayIndex, (form_inputs.shadeDisplayIndex)? 'numeric' : '')}
                                </div>
                               

                                <div className='text-center'>
                                    <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                        {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Save
                                    </button>
                                    <Link to="/shades" className="btn btn-danger ms-3"> Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Item;